// extracted by mini-css-extract-plugin
export default {"container":"NoticiaFiltro_container__XfkgF","search":"NoticiaFiltro_search__LOW24","sort":"NoticiaFiltro_sort__v+cau"};